import type { MailboxInfo } from 'owa-client-types';
import { getAccountScopeUserSettings } from '../selectors/getAccountScopeUserSettings';
import type OutlookFavorites from 'owa-service/lib/contract/OutlookFavorites';
import type RecursiveReadOnly from 'owa-service/lib/RecursiveReadOnly';

export default function getFavorites(
    mailboxInfo: MailboxInfo
): RecursiveReadOnly<OutlookFavorites | undefined> {
    return getAccountScopeUserSettings(mailboxInfo).Favorites;
}
